import soc2Image from '@/assets/images/badges/soc2.png';
import { DOCS_URL } from '@/shared/constants/docs';
import { useTrans } from '@/shared/hooks/useTranslation';
import { formatDisplayVersion } from '@/shared/utils';

const SOC2_URL = `${DOCS_URL}/compliance/about`;
const TERMS_URL = `${DOCS_URL}/compliance/Transparency/terms-of-service`;
const PRIVACY_URL = `${DOCS_URL}/compliance/Transparency/privacy-policy`;

export function Footer() {
  const { t } = useTrans();
  const year = new Date().getFullYear();
  const version = import.meta.env.VITE_APP_VERSION;
  const displayVersion = version ? formatDisplayVersion(version) : undefined;

  return (
    <footer className="shrink-0 flex items-center justify-between gap-4 h-[5vh] min-h-10 px-4 sm:px-6 md:px-8 lg:px-16 bg-surface border-t border-border">
      <div className="flex items-center gap-3 text-xs text-foreground/40">
        {displayVersion ? (
          <>
            <span className="rounded-full border border-border px-2 py-0.5 font-mono text-2xs leading-4">
              v{displayVersion}
            </span>
            <span className="text-border">|</span>
          </>
        ) : null}
        <a
          href={SOC2_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1 hover:text-foreground/70 transition-colors"
        >
          <img src={soc2Image} alt="SOC 2" className="w-5 h-5 drop-shadow-md object-cover" />
          {t('footer.soc2')}
        </a>
        <span className="text-border">|</span>
        <a
          href={TERMS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-foreground/70 transition-colors"
        >
          {t('footer.terms')}
        </a>
        <span className="text-border">|</span>
        <a
          href={PRIVACY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-foreground/70 transition-colors"
        >
          {t('footer.privacy-policy')}
        </a>
      </div>
      <span className="text-xs text-foreground/40">
        {t('footer.copyright', { year })}{' '}
        <a
          href="https://teramot.com"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-foreground/70 transition-colors"
        >
          Teramot
        </a>
      </span>
    </footer>
  );
}
